import { Me } from '../../../typings';
import { getFetch } from '../fetch';
import { apiConfig } from '../config';

export function getMe(): Promise<Me> {
    const { apiGetMe } = apiConfig.getStaticUrls();

    return getFetch(apiGetMe);
}
